import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
import User from './modules/user';
import getters from './getters';





const store = new Vuex.Store({
    strict: true,
    modules: {
        User: User,
    },
    getters

})
export default store